import { IApiResponse } from "../types/INote";
import urlStore from "./urlStore";
import logger from "../services/logger";

export default async function getData(xx: string, endpoint: string, limit?: number): Promise<IApiResponse> {
  let url = `${urlStore.urlJSON}${xx}/${endpoint}`;
  let separator = "?";

  if (limit) {
    if (url.includes("?")) {
      separator = "&";
    }
    url += `${separator}limit=${limit}`;
  }

  return fetch(url, {
    cache: "no-cache",
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((err) => {
      logger.error(err);
    });
}
